import styled from 'styled-components';
import { Typography } from '@mui/material';

import Select from '../../../../../components/v2/Select';

const RecipientActionsContainer = styled.div`
  margin: 5px 0 20px 0;
  display: flex;
  justify-content: flex-end;
  row-gap: 10px;
  align-items: center;
`;

const StyledSelectField = styled(Select)`
  margin-bottom: 20px;
`;

const StyledTypography = styled(Typography)`
  font-size: 12px;
`;

export {
  RecipientActionsContainer,
  StyledSelectField,
  StyledTypography,
};
